import { IconButton, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { ChangeEvent, useState } from 'react';
import { MdClear } from 'react-icons/md';

interface SearchFormFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  clearable?: boolean;
}

const SearchFormField: React.FC<SearchFormFieldProps> = ({
  value,
  onChange,
  placeholder,
  clearable = true,
}) => {
  const [internalValue, setInternalValue] = useState<string>(value ?? '');

  function handleChange(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    setInternalValue(e.target.value);
    if (onChange) onChange(e.target.value);
  }

  function onClear() {
    setInternalValue('');
    if (onChange) onChange('');
  }

  return (
    <>
      <InputGroup>
        <Input
          value={internalValue}
          bg="white"
          w="100%"
          h="48px"
          variant="outline"
          placeholder={placeholder ?? ''}
          label={placeholder ?? ''}
          onChange={handleChange}
        />

        {clearable && internalValue.length && (
          <InputRightElement
            h="48px"
            right="4px"
            children={
              <IconButton
                variant="ghost"
                color="gray.600"
                aria-label="clear"
                icon={<MdClear fontSize="18px" />}
                onClick={onClear}
              />
            }
          />
        )}
      </InputGroup>
    </>
  );
};

export default SearchFormField;
